import styled, { css } from 'styled-components';
import { THEME } from '../../../../../themes';
import { ASSETS } from '../../../../../assets';
import Chip from '../../../../../components/Common/perfect-chip/perfect-chip.component';
import { Body2Font } from '../../../../../themes/fonts';
import { hexToRgbA } from '../../../../../utils/colors';

export const SKILLS_CHIP_GAP_PX = 8;

const defineItemsContainerHeight = (isExpended: boolean, minimizedHeight: number, fullHeight?: number) => {
  const extraContainerPaddingPx = 2; // Because the container overflow hidden cuts the chips border

  if (!isExpended) {
    return minimizedHeight !== -1 ? `${minimizedHeight + extraContainerPaddingPx}px` : 'unset';
  }

  return (fullHeight === -1 || !fullHeight) ? 'unset' : `${fullHeight + extraContainerPaddingPx}px`;
};

export const ChipsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${THEME.SPACING.TINY};
`;

export const ChipsContainerWrapper = styled.div<{ isExpended: boolean, fullHeight: number, minimizedHeight: number }>`
  overflow: hidden;
  transition: 200ms;
  padding-top: 1px; //The reason is that the overflow hidden hides the chips upper border
  height: ${({ isExpended, minimizedHeight, fullHeight }) => defineItemsContainerHeight(isExpended, minimizedHeight, fullHeight)};
`;

const ChipStyle = css`
  ${Body2Font};
  font-weight: 500;
  border-radius: ${THEME.RADIUS.BASE};
`;

export const AdditionalSkillChip = styled(Chip)`
  ${ChipStyle};
  color: ${THEME.COLORS.PRIMARY};
  background-color: ${hexToRgbA(THEME.COLORS.PRIMARY, THEME.OPACITY.GHOST)};
`;

export const AskedByUserChip = styled(Chip)`
  ${ChipStyle};
  color: ${THEME.COLORS.SECONDARY};
  background-color: ${hexToRgbA(THEME.COLORS.SECONDARY, THEME.OPACITY.GHOST)};
`;

const IconCss = css`
  width: 12px;
  height: 12px;
  fill: ${THEME.COLORS.SECONDARY};
`;

export const CheckedStarIcon = styled(ASSETS.CHECK_STAR)`
  ${IconCss};
`;

export const TempleIcon = styled(ASSETS.TEMPLE)`
  ${IconCss};
`;

export const VSignIcon = styled(ASSETS.V_SIGN)`
 ${IconCss};
`;

export const ContainerIcon = styled(ASSETS.EXPERIENCE_STARS)``;
